//authentication
export const loginEndpoint = "Authentication/LogIn";
//loginOtpVerify
export const loginOTPEndpoint = "Authentication/VerifyOTPLogin";
//active batch
export const activeBatchEndPoint = "Batch/GetActiveBatch";
//create batch
export const createBatchEndPoint = "Batch/CreateBatch";
//get all batches
export const getAllBatchesEndPoint = "Batch/GetAllBatchs";
//update batch
export const updateBatchEndPoint = "Batch/UpdateBatch";
//file upload
export const fileUploadEndPoint = "File/FileUpload";
//transactions
export const batchByTransactions = "Transection/GetAllTransectionsByBatchId";
//get all users
export const getAllUsersEndPoint = "User/GetAllUsers";
//update user
export const updateUserEndPoint = "User/UpdateUser";
//get  dashboard details
export const dashboadDetailsEndPoint = "Batch/DashboardListAPI";
//create winner
export const createWinner = "Home/CreateWinner";
//get recently drawn batch
export const recDrawnBatchEndPoint = "Batch/GetRecentlyDrwanBatch";
//get slected user by id
export const userByIdEndpoint = "User/GetSelectedUser?id=";
//getBatchById
export const batchByIdIdEndpoint = "Batch/GetBatchById?batchId=";

//deleteUser WithOTP
export const DeleteUserWithOTP = "User/DeleteUser";
//verifyDeleteUserWithOTP
export const VerifyDeleteUserWithOTP = "User/VerifyOTPDeleteUser"

//recipt download 

export const reciptDownload = "File/DownlaodReceipt?transectionId="